<template>
	<section>
		<div>
			<slot />
		</div>
	</section>
</template>

<style lang="css" scoped>
section > div
{
	max-width: 1160px;
	height: 100%;
	margin: 0 auto;
	padding: 4rem 2rem;
	box-sizing: border-box;
	min-height: 50vh;
}
</style>